import { render, staticRenderFns } from "./commonTags.vue?vue&type=template&id=7076f92d&scoped=true&"
import script from "./commonTags.vue?vue&type=script&lang=js&"
export * from "./commonTags.vue?vue&type=script&lang=js&"
import style0 from "./commonTags.vue?vue&type=style&index=0&id=7076f92d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7076f92d",
  null
  
)

export default component.exports